import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  recommendationLabel: {
    id: 'scenario_recommendation_label',
  },
});
